import _createClass from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
export var Service = /*#__PURE__*/_createClass(function Service(axiosInstance) {
  _classCallCheck(this, Service);

  _defineProperty(this, "axiosInstance", void 0);

  this.axiosInstance = axiosInstance;
});